import { OutboundCallEntity } from '@lib/types/common-call-types';
import { OutboundCallDetails } from '../types';

export const initialCallDetails: OutboundCallDetails = {
  number: '',
  callDisplayName: '',
  entity: OutboundCallEntity.Employees,
};
